
import SearchCards from '@/components/SearchCards'
import tableLoading from '@/components/tableLoading';
import loaderComponent from '@/components/loaderComponent'
import PageHeader from '@/components/core/PageHeader';
import PackageCard from "@/components/PackageCard";
import RestaurantCard from "@/components/RestaurantCard";
import ActivityCard from "@/components/ActivityCard.vue";

export default {
  components: {
    SearchCards,
    loaderComponent,
    PageHeader,
    PackageCard,
    RestaurantCard,
    tableLoading,
    ActivityCard
  },
  scrollToTop: true,
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title + " | Goa App" : " Tags | Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage()
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title + " | Goa App" : " Tags | Goa App",
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage()
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage()      
      },      
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title + " | Goa App" : " Tags | Goa App",
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      },
        // {
        //   hid: 'robots',
        //   name: 'robots',
        //   content: 'noindex'
        // },
      ],
    }
  },
  data() {
    return {
      title: 'Search',
      tagsData: [],
      search: '',
      isSearchClicked: false,
      listings: null,
      loading: true,
      listingLoading: true,
      tagSlug: null,
      seoData: null,
    }
  },

  async asyncData({ error, route, $axios }) {
    try {
      let data = await $axios.get('/api/tags/getTagSEOContent/' + route.params.index)
    } catch {
      error({ statusCode: 404, message: 'Post not found' })
    }
  },


  // fetchOnServer: false,

  async validate({
    params,
    store
  }) {
    // await operations
    if (params.index != (null || "")) {
      this.tagSlug = params.index;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.tagSlug = this.$route.params.index;
  },


  mounted() {
    this.tagSlug = this.$route.params.index;
    this.getAllData()
  },
  methods: {


    async getAllData() {
      //Get the list of post data
      this.seoData = await fetch(this.$config.fetchUrl + '/api/tags/getTagSEOContent/' + this.tagSlug)
        .then(res => res.json());
      this.$nextTick(() => {
        this.loading = false
      })

      this.listings = await fetch(this.$config.fetchUrl + '/api/search/tag/' + this.tagSlug)
        .then(res => res.text());
      this.listings = this.getCryptKey(this.listings);
      this.$nextTick(() => {
        this.listingLoading = false
      })
    },

    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return 'Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.'
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return 'Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency'
      }
    },
    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      }
      else {
        return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
      }
    },

    activitiesImage(post) {
      if (post.gallery && post.gallery.length > 0)
        return post.gallery[0]
      return '';
    },
    
  }
}
